module.exports = __webpack_public_path__ + "assets/img/sword.ac730d6e.png";